import React from 'react';
import { Typography, Box, Chip } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import SectionCard from '../ui/SectionCard';
import { STATUS_LABELS, getStatusHex } from '../../constants/status';
import { formatDateTime } from '../../utils/format';

// timeline แนวตั้ง เลียนแบบ StatusHistoryList.js/OwnerHistoryList.js — note field บน opportunity
// เอง (OpportunityInfoCard) ยังแก้ทับได้เหมือนเดิม การ์ดนี้แค่โชว์ log ทุกครั้งที่เคยบันทึกไว้
// (เขียนอัตโนมัติฝั่ง backend ใน updateOpportunity — ดู opportunity.repository.js) พร้อม status
// ของ opportunity ณ ตอนที่บันทึก note นั้น เพื่อรู้บริบทว่า note นี้พูดถึงตอนไหนของงาน
export function NoteHistoryList({ history, creatorNameByUserId }) {
  const items = (history || []).slice().reverse();

  return (
    <SectionCard icon={<EditNoteOutlinedIcon />} title="ประวัติการบันทึก Note" accentColor="grey.500">
      {items.length === 0 ? (
        <Typography variant="body2" color="text.secondary">ยังไม่มีประวัติ</Typography>
      ) : (
        <Box>
          {items.map((h, idx) => (
            <Box key={h.id} sx={{ display: 'flex', gap: 1.5 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 12, flexShrink: 0 }}>
                <Box
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    flexShrink: 0,
                    mt: 0.6,
                    bgcolor: getStatusHex(h.status),
                  }}
                />
                {idx < items.length - 1 && (
                  <Box sx={{ width: '1px', flex: 1, bgcolor: 'divider', my: 0.5 }} />
                )}
              </Box>
              <Box sx={{ pb: idx < items.length - 1 ? 2 : 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                  {h.status && (
                    <Chip
                      size="small"
                      label={STATUS_LABELS[h.status] || h.status}
                      sx={{
                        height: 18,
                        fontSize: '0.68rem',
                        color: getStatusHex(h.status),
                        borderColor: getStatusHex(h.status),
                      }}
                      variant="outlined"
                    />
                  )}
                  <Typography variant="caption" color="text.secondary">
                    {formatDateTime(h.changed_at)}
                    {h.changed_by && ` — ${creatorNameByUserId?.[h.changed_by] || '(ไม่ทราบชื่อ)'}`}
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mt: 0.25, whiteSpace: 'pre-wrap' }}>{h.note}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </SectionCard>
  );
}

export default NoteHistoryList;
